var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDidYouKnow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ffca0e;}.cls-3{fill:#ffdf00;opacity:0.7;}.cls-3,.cls-5,.cls-7{mix-blend-mode:multiply;}.cls-4{fill:#53564e;}.cls-5,.cls-7{fill:#a1a1a1;}.cls-5{opacity:0.5;}.cls-6{fill:#fff;}.cls-7{opacity:0.2;}.cls-8{fill:#ffbd00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.06,230.78A119.06,119.06,0,0,0,244.29,111.85c-61,2.85-110.44,52.34-113.23,113.34a118.69,118.69,0,0,0,34.65,89.65,89.61,89.61,0,0,1,24.73,45.38l3,14.66a13,13,0,0,0,12.76,10.45h87.68a13,13,0,0,0,12.76-10.45l3-14.67a87.47,87.47,0,0,1,24.19-44.83A118.67,118.67,0,0,0,369.06,230.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M295.24,343.75a130.24,130.24,0,0,1-103.57-216.7C157,146.68,133,183.21,131.06,225.19a118.69,118.69,0,0,0,34.65,89.65,89.61,89.61,0,0,1,24.73,45.38l3,14.66a13,13,0,0,0,12.76,10.45h87.68a13,13,0,0,0,12.76-10.45l3-14.67a87.31,87.31,0,0,1,6.23-19.12A128.9,128.9,0,0,1,295.24,343.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 195.15,
    y: 385.33,
    width: 109.7,
    height: 24.16,
    rx: 4.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M210.31,397.46v-.11a12,12,0,0,1,12-12H207.18a12,12,0,0,0-12,12v.11a12,12,0,0,0,12,12h15.16A12,12,0,0,1,210.31,397.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 195.15,
    y: 409.49,
    width: 109.7,
    height: 24.16,
    rx: 4.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M210.31,421.62v-.11a12,12,0,0,1,12-12H207.18a12,12,0,0,0-12,12v.11a12,12,0,0,0,12,12h15.16A12,12,0,0,1,210.31,421.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 195.15,
    y: 433.65,
    width: 109.7,
    height: 24.16,
    rx: 4.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M210.31,445.79v-.11a12,12,0,0,1,12-12H207.18a12,12,0,0,0-12,12v.11a12,12,0,0,0,12,12h15.16A12,12,0,0,1,210.31,445.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M276.61,457.81S272.54,471,250,471s-26.61-13.22-26.61-13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M235.43,461.51h39.08a13.33,13.33,0,0,0,2.1-3.7H223.39s3.71,12,23.55,13.12C237.47,468,235.43,461.51,235.43,461.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.81,165.07c-1.82,1.94-5.25,1.68-7.66-.58s-2.88-5.67-1.06-7.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M322,491.53c0,5.31-32.23,9.61-72,9.61s-72-4.3-72-9.61,32.24-9.62,72-9.62S322,486.22,322,491.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M250,3.11a6.35,6.35,0,0,0-6.34,6.34V54.78a6.34,6.34,0,1,0,12.68,0V9.45A6.35,6.35,0,0,0,250,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92.4,72.1a6.34,6.34,0,0,0-9,9l32.06,32.05A6.26,6.26,0,0,0,120,115a6.33,6.33,0,0,0,6.34-6.34,6.26,6.26,0,0,0-1.86-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M384.52,364.22a6.35,6.35,0,0,0-9,0,6.36,6.36,0,0,0,0,9l32.05,32.05a6.34,6.34,0,1,0,9-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M20.78,232.33a6.34,6.34,0,0,0,0,12.68H66.11a6.34,6.34,0,1,0,0-12.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M479.22,232.33H433.89a6.34,6.34,0,1,0,0,12.68h45.33a6.34,6.34,0,0,0,0-12.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M120,362.36a6.26,6.26,0,0,0-4.48,1.86l-32.06,32a6.34,6.34,0,0,0,9,9l32.05-32.05A6.35,6.35,0,0,0,120,362.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M380,115a6.29,6.29,0,0,0,4.48-1.86l32.06-32.05a6.34,6.34,0,0,0-9-9l-32.06,32.06A6.34,6.34,0,0,0,380,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M159.63,3.92A6.34,6.34,0,0,0,153.76,0a6.12,6.12,0,0,0-2.42.49,6.24,6.24,0,0,0-3.43,3.43,6.28,6.28,0,0,0,0,4.85L173.77,71.2a6.32,6.32,0,0,0,5.86,3.92,6.22,6.22,0,0,0,2.42-.48,6.35,6.35,0,0,0,3.44-8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M15.25,148.3l62.43,25.86a6.34,6.34,0,0,0,4.85-11.72L20.1,136.58a6.34,6.34,0,0,0-4.85,11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M484.75,329.05l-62.42-25.86a6.21,6.21,0,0,0-2.43-.49,6.35,6.35,0,0,0-5.86,8.77,6.24,6.24,0,0,0,3.43,3.43l62.43,25.86a6.34,6.34,0,1,0,4.85-11.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M86,306.62a6.34,6.34,0,0,0-8.28-3.44L15.25,329.05a6.34,6.34,0,1,0,4.85,11.71L82.53,314.9A6.34,6.34,0,0,0,86,306.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M414,165.87a6.34,6.34,0,0,0,8.28,8.29l62.43-25.86a6.35,6.35,0,0,0-2.43-12.21,6.34,6.34,0,0,0-2.42.49l-62.43,25.86A6.27,6.27,0,0,0,414,165.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M348.67.49A6.21,6.21,0,0,0,346.24,0a6.32,6.32,0,0,0-5.86,3.92L314.51,66.35a6.33,6.33,0,0,0,3.43,8.28,6.17,6.17,0,0,0,2.43.49,6.32,6.32,0,0,0,5.86-3.92L352.09,8.77A6.34,6.34,0,0,0,348.67.49Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDidYouKnow);
export default __webpack_public_path__ + "static/media/did_you_know.b4d929921d4be898dcc9740ab2edf376.svg";
export { ForwardRef as ReactComponent };